import { createMuiTheme } from "@material-ui/core/styles";
import { ptBR } from "@material-ui/core/locale";

export const theme = createMuiTheme(ptBR);
